/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

/**
 * The service status of the organization
 */
export type GetOrganization200ServiceStatus =
  (typeof GetOrganization200ServiceStatus)[keyof typeof GetOrganization200ServiceStatus];

export const GetOrganization200ServiceStatus = {
  ACTIVE: "ACTIVE",
  FREE_TRIAL: "FREE_TRIAL",
  PAYMENT_REQUIRED: "PAYMENT_REQUIRED",
  PAYMENT_FAILED: "PAYMENT_FAILED",
} as const;
